export default "__VITE_ASSET__06053566__"